import { colors, mixin, sizes } from "@hubrise/react-components"
import styled from "styled-components"

export const ImageHolder = styled.div`
  ${mixin.centerElement};
  background-color: ${colors.backgroundLight};
  border-top-left-radius: ${sizes.borderRadius};
  border-top-right-radius: ${sizes.borderRadius};
`

export const StyledImage = styled.img`
  max-width: 100%;
  max-height: 25rem;
  object-fit: contain;
`
